
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reject",
      function () {
        return require("private-next-pages/reject.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reject"])
      });
    }
  